import { Button } from "./ui/button";
import heroImage from "../assets/company-formation-hero.jpg";

const CompanyFormationHero = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Hero Image */}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative">
        <img 
          src={heroImage} 
          alt="Company Formation and Business Incorporation Services"
          className="w-full h-full object-cover"
        />
        {/* Blue to purple overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/60 to-purple-600/60"></div>
      </div>
      
      {/* Hero Content */}
      <div className="absolute inset-0 flex items-start justify-center pt-6 md:pt-8">
        <div className="text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
            Start Your Business the Right Way
          </h1>
        </div>
      </div>
    </section>
  );
};

export default CompanyFormationHero;